import { render } from "./PlayerAlliedParty.vue?vue&type=template&id=89a6de8e&ts=true"
import script from "./PlayerAlliedParty.vue?vue&type=script&lang=ts"
export * from "./PlayerAlliedParty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__